import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserCompany } from '@company/const';
import { CompanyService } from '@company/feature';
import { ModalService } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user';
import { User } from '@user/const';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-select-company-modal',
  templateUrl: './select-company-modal.component.html',
  styleUrls: ['./select-company-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdSelectCompanyModalComponent implements OnInit {
  userCompanies$: Observable<UserCompany[]>;
  user$: Observable<User>;

  constructor(
    private companyService: CompanyService,
    private modalService: ModalService,
    private userAccountService: UserAccountFacade,
  ) {}

  ngOnInit(): void {
    this.user$ = this.userAccountService.get();
    this.userCompanies$ = this.companyService.getUserCompanies();
  }

  selectCompany(companyUid: string): void {
    this.companyService.selectCompany(companyUid);
    this.closeModal();
  }

  resetSelectedCompany(): void {
    this.companyService.resetSelectedCompany();
    this.closeModal();
  }

  closeModal(): void {
    this.modalService.closeActiveModal();
  }
}
